import Vue from '@triotech/vue-core/src/vendor/vue';
import AjaxMixin from '@triotech/vue-core/src/mixins/plugins/ajax';

const Ajax = new Vue({
  mixins: [
    AjaxMixin,
  ],
  methods: {
    addVersionInConfig(config = {}) {
      if (!config.headers) {
        config.headers = [];
      }

      config.headers = this._.extend({
        Version: this.$config.get('api.version'),
      }, config.headers);

      return config;
    },
    addPlayerKindInConfig(config = {}) {
      if (!config.headers) {
        config.headers = [];
      }

      config.headers = this._.extend({
        PlayerKind: this.$store.getters.get.player,
      }, config.headers);

      return config;
    },
    addHeadersInHeader(config) {
      return this.addPlayerKindInConfig(this.addVersionInConfig(config));
    },
    build(url, method, data = {}, config = {}) {
      return this._.extend(url === this.oauthTokenEndpoint ? config : this.addHeadersInHeader(config), { url, method, data });
    },
    login(data, persistSession = true) {
      return this.oauth(this._.extend({
        grant_type: `urn:${this.$helper.isPlayerDemo36 ? 'demo36' : 'switch'}_token`,
      }, data), persistSession);
    },
    addSubEndPointToUrl(url = '') {
      if (!this.$helper.isPlayerDemo12 && url && url.indexOf('://') === -1) {
        return this.$config.get('subendpoint') + url;
      }

      return url;
    },
    getUploadsUri(location) {
      return this.url(this.build(`uploads${location}`), true);
    },
    get(url, data, config) {
      return this.request(this.build(this.addSubEndPointToUrl(url), this.http.get, data, config));
    },
    post(url, data, config) {
      return this.request(this.build(this.addSubEndPointToUrl(url), this.http.post, data, config));
    },
  },
});

Vue.set(Vue.prototype, '$ajax', Ajax);

export default Ajax;
